import { buildUrl } from '@helper/utils/format'

export const LANDING_ROUTES = {
  home: '/',
  guru: '/guru',
  sekolah: '/sekolah',
  orangTua: '/orang-tua',
  sumberDaya: '/sumber-daya-gratis',
  beasiswa: '/dampak',
  jelajahi: '/explore',
  freeResourcesBlog: '/blog/free-resources',
  teachingBlog: '/blog/teaching-strategy',
  terms: '/syarat-dan-ketentuan',
  privacy: '/kebijakan-privasi',
} as const

export const SIGNUP_URL = {
  teacher: buildUrl('account', '/daftar', { signup_type: 'teacher' }).href,
  parent: buildUrl('account', '/daftar', { signup_type: 'parent' }).href,
  kid: buildUrl('account', '/anak').href,
} as const
